import useSWR from 'swr'
import API from '../../utils/api'
import { getPersistData } from '../../app/hooks/persist'
import { useToken } from 'app/hooks'
import {useState} from "react";

const KEY = '/dashboard/noti?unread=0&page=1&maxData=99999999'

let swrData: any = getPersistData(KEY)

export function useReadNotiList() {
	const { data: token } = useToken()
	const [refreshIndex, setRefreshIndex] = useState(0);

	const { data, mutate } = useSWR<any>(
		KEY ,
		async () => {
			const response = await API.get(KEY, token + '', {})
			swrData = response.result?.result?.list

			return swrData
		},
		{ revalidateOnFocus: true, refreshInterval: 30000  }
	)


	return {
		readNotiList: data,
		readNotiListMutate: mutate
	}
}